require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./polk-county-community-corrections-transitional-housing.json") })
        }
      }, "path---polk-county-community-corrections-transitional-housing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---polk-county-community-corrections-transitional-housing!./.cache/json/polk-county-community-corrections-transitional-housing.json
// module id = 955
// module chunks = 231608221292675